import { Attachment, SkeletonData, SkinEntry, SkeletonMesh } from '@esotericsoftware/spine-threejs';

export type ToolLocation = 'mouth' | 'eyes' | 'chest' | 'thighs' | 'legs'

export class Tool {

  public attachment: Attachment
  public heldAttachment: Attachment | null = null
  public heldAttachments: Attachment[]
  public name: string
  public possibleLocations: ToolLocation[] = []
  public cost: number
  public isHoldOnly: boolean

  constructor(attachment: Attachment, heldAttachment?: Attachment | null, cost?: number) {
    this.attachment = attachment
    this.name = Tool.getShortName(attachment)
    this.possibleLocations = Tool.getToolLocations(this.name)
    this.isHoldOnly = this.possibleLocations.length === 0
    this.heldAttachments = []
    
    this.cost = cost || Math.floor(Math.random() * 60) + 1
    
    if(heldAttachment) {
      this.setHeldAttachments([heldAttachment])
    }
    
  }

  static getShortName(attachment: Attachment) {
    return attachment.name.split('/').pop() ?? attachment.name
  }

  public setHeldAttachments(arr: Attachment[]) {
    if(arr && arr.length) {
      this.heldAttachment = arr[0]
      this.heldAttachments = arr
    } 
  }

  static getToolLocations(name: string): ToolLocation[] {
    
    let ret = [] as ToolLocation[]
    if(/gag$/.test(name) || /tape\d+$/.test(name) || /^cloth/.test(name) || name === 'panties') {
      ret.push('mouth')
    }


    if(/tape\d+$/.test(name) || /^cloth/.test(name)) {
      ret.push('eyes')
    }

    if(name === 'rope') {
      ret.push('chest', 'thighs', 'legs')
    }

    return ret
  }

  public copy() {
    return new Tool(this.attachment, this.heldAttachment, this.cost)
  }

}

export default class ToolFactory {
  private skeletonData: SkeletonData
  constructor(data: SkeletonData) {
    this.skeletonData = data
  }

  private isToolAttachment(skinEntry: SkinEntry) {
    return /^tools\/[a-zA-Z0-9]+$/.test(skinEntry.name)
  }

  private isHeldAttachment(skinEntry: SkinEntry) {
    return /^tools\/holding_[a-zA-Z0-9]+$/.test(skinEntry.name)
  }

  public getTools() {
    const attachments = this.skeletonData.defaultSkin?.getAttachments() || []
    const tools = attachments.filter(this.isToolAttachment)
    const holdables = attachments.filter(this.isHeldAttachment)
    return tools.map(t => {
      const newTool = new Tool(t.attachment)
      const toolHoldables = holdables.filter(h => h.name.includes(Tool.getShortName(t.attachment)))
      if(toolHoldables && toolHoldables.length > 0) {
        newTool.setHeldAttachments(toolHoldables.map(t => t.attachment))
      }
      return newTool
    })
  }


  // fix this 
  // rename this
  public getMesh(tool: Tool) {

    const type = tool.heldAttachment ? 'holding' : 'tool'
    const attachment = tool.heldAttachment || tool.attachment

    const mesh = new SkeletonMesh(this.skeletonData, (parameters) => {
      parameters.depthTest = false;
      parameters.alphaTest = 0.5;
    })

    const newSkin = mesh.skeleton.data.defaultSkin


    if(newSkin) {
      newSkin.getAttachments().forEach(a => {
        if(a.name !== attachment.name)
          newSkin.removeAttachment(a.slotIndex, a.name)
      })

      const slot = mesh.skeleton.data.findSlot(type)
      if(slot && slot.attachmentName) {
        newSkin.setAttachment(slot.index, slot.attachmentName, attachment)
      }

      mesh.skeleton.setSkin(newSkin);
      mesh.skeleton.setSlotsToSetupPose();
      mesh.state.apply(mesh.skeleton)

    
    }


    // const skin = new Skin(tool.name)

    // const slot = mesh.skeleton.data.findSlot(type)

    // console.log('slot', slot)
    // console.log('skin', skin)
    // console.log('cur skin', mesh.skeleton.skin)

    // if(slot) {

    //   skin.setAttachment(slot.index, slot.name, attachment)
      
    //   mesh.skeleton.setSkin(skin);

    //   const nonSlot = mesh.skeleton.data.findSlot(nonType)
    //   if(nonSlot && mesh.skeleton.skin) {
    //     console.log('removing non slot', nonSlot)
    //     mesh.skeleton.skin.removeAttachment(nonSlot.index, nonSlot.attachmentName || '')
    //   }

    //   mesh.skeleton.setSlotsToSetupPose();
    //   mesh.state.apply(mesh.skeleton)

    // }

    

    return mesh
  }
  



}